
export const SET_CUSTOMER_CHAT = "SET_CUSTOMER_CHAT";   
export const APPEND_CUSTOMER_CHAT = "APPEND_CUSTOMER_CHAT";   